export default __webpack_public_path__ + "static/media/1683.5085225e.png";